import Axios from 'axios';
import URL from '../../Environment';
import React, { useEffect, useState } from "react";
import { Link, useParams } from 'react-router-dom';
// import './personalloandetail.css';

const PersonalLoanDetail = () => {
  const { id } = useParams();
  const [loanData, setLoanData] = useState(null);
  const [loanLoading, setLoanLoading] = useState(true);
  const [errorLoan, setLoanError] = useState(null);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const response = await Axios.get(`${URL}api/PersonalLoanAds/getLoansDataInfobyId?id=${id}`);
        console.log('Response:', response.data);
        setLoanData(response.data);
        setLoanLoading(false);
      } catch (error) {
        console.log('Error:', error);
        setLoanError(error);
        setLoanLoading(false);
      }
    };

    if (id) {
      fetchLoanData();
    }
  }, [id]);

  // เพิ่ม useEffect เพื่อแก้ไข table classes
  useEffect(() => {
    if (loanData) {
      // หา table ทั้งหมดใน loan-detail-content
      const tables = document.querySelectorAll('.loan-detail-content table');
      
      tables.forEach(table => {
        // เพิ่ม Bootstrap table classes
        table.classList.add('table', 'table-bordered', 'table-striped', 'table-condensed', 'table-hover');
        
        // ลบ inline width styles ออก
        table.style.width = '100%';
        table.removeAttribute('class'); // ลบ class เดิม
        table.classList.add('table', 'table-bordered', 'table-striped', 'table-condensed', 'table-hover');
        
        // ลบ inline styles ออกจาก th และ td
        const cells = table.querySelectorAll('th, td');
        cells.forEach(cell => {
          // เก็บ rowspan attribute ไว้
          const rowspan = cell.getAttribute('rowspan');
          
          // ลบ inline styles
          cell.removeAttribute('style');
          
          // ใส่ rowspan กลับคืน ถ้ามี
          if (rowspan) {
            cell.setAttribute('rowspan', rowspan);
          }
        });

        // จัดการ thead ถ้ามี
        const firstRow = table.querySelector('tbody tr:first-child');
        if (firstRow && firstRow.querySelectorAll('th').length > 0) {
          const thead = document.createElement('thead');
          const tbody = table.querySelector('tbody');
          
          // ย้าย row แรกไป thead
          thead.appendChild(firstRow);
          table.insertBefore(thead, tbody);
          
          // เพิ่ม style สำหรับ thead
          const headerCells = thead.querySelectorAll('th');
          headerCells.forEach(cell => {
            cell.style.color = '#ffffff';
            cell.style.backgroundColor = '#76797cff';
          });
        }
      });
    }
  }, [loanData]);

  if (loanLoading) {
    return <div>Loading...</div>;
  }

  if (errorLoan) {
    return <div>Error: {errorLoan.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <Link to="/personalloan" className="a-breadcrumbs">
                {loanData?.topic || 'เงินกู้ฉุกเฉิน'}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50 Infomation-Font" style={{width: '90%', fontFamily: '"Cordia New"'}}>
              {loanData ? (
                <>
                  <h2 className="title-section mt-0 mb-0">
                    <span>{loanData.topic}</span>
                  </h2>
                  <br/>
                  <div className="divider gray left mt-20 mb-25" />
                  
                  {/* แสดง description เป็น raw HTML */}
                  <div 
                    className="loan-detail-content"
                    dangerouslySetInnerHTML={{ __html: loanData.description }}
                  />

                  {loanData.ContentDetail && (
                    <div 
                      className="loan-detail-content"
                      dangerouslySetInnerHTML={{ __html: loanData.ContentDetail }}
                    />
                  )}

                  {loanData.attachfile && (
                    <div className="mt-25">
                      <a 
                        href={loanData.attachfile} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                      >
                        ดาวน์โหลดเอกสารแนบ
                      </a>
                    </div>
                  )}

                  {loanData.link && (
                    <div className="mt-25">
                      <a 
                        href={loanData.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{color: '#4db6f1'}}
                      >
                        <u>ลิงก์ข้อมูลเพิ่มเติม</u>
                      </a>
                    </div>
                  )}

                  {/* เพิ่มตรงนี้ */}
                  {loanData.id === 2 && (
                    <>
                      <br/><br/>
                      <div className="row">
                        <div className="col-md-12 mb-sm-50">
                          <div className="divider gray left mt-20 mb-25" />
                          <h4>วิธีกดเงินกู้ฉุกเฉิน</h4>
                          <div className="embed-responsive embed-responsive-16by9" style={{maxWidth: '850px'}}>
                            <iframe
                              className="embed-responsive-item"
                              src="https://www.youtube.com/embed/ay2U-l7izjg"
                              allowFullScreen
                              title="วิธีกดเงินกู้ฉุกเฉิน"
                              style={{width: '100%', height: '478px'}}
                            />
                          </div>
                        </div>
                      </div>
                      <br/><br/>
                    </>
                  )}

                  <br/>
                  <br/>
                  <br/>
                </>
              ) : (
                <div className="text-center">
                  <p>ไม่พบข้อมูล</p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PersonalLoanDetail;